
import state from './moduleKindsState.js'
import mutations from './moduleKindsMutations.js'
import actions from './moduleKindsActions.js'
import getters from './moduleKindsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
